interface appConfig {
	api_url: string;
	projectId: string;
	tenantId: string;
	defaultPageSize: number;
	defaultRowsPerPageOptions: number[];
	autoHeight: boolean;
	tableHeight: any;
	shrinkTableHeight: any;
	mBorder: any;
	version: string;
	mInternalPadding: any;
	snackbarTimeout: number;
}

const AppConfig: appConfig = {
	// api_url: 'https://bank.tkb-kakuma.com',
	api_url: 'https://sandboxapi.tkb-kakuma.com',
	tenantId:
		process.env.NODE_ENV === 'production'
			? 'kakuma'
			: (process.env.REACT_APP_TENANT_ID ?? 'kakuma'),
	projectId: '1',
	version: 'V0.0.12',
	defaultPageSize: 50,
	defaultRowsPerPageOptions: [50, 100, 200, 400],
	autoHeight: false,
	tableHeight: '70vh',
	shrinkTableHeight: '50vh',
	mBorder: '1px solid rgb(216,216,216)',
	mInternalPadding: 1,
	snackbarTimeout: 3000,
};

export function setTenantId(tenantId?: string) {
	if (tenantId) {
		AppConfig.tenantId = tenantId;
	}
}

export default AppConfig;
